import React, { useState, useRef, useEffect } from "react";
import { View, Image } from "react-native";

const ImageComponent = ({ uri, resizeMode = "cover", style }) => {
  const img = useRef(null);
  const [dim, setDim] = useState({ height: 0, width: 0 });
  useEffect(() => {
    Image.getSize(uri, (width, height) => {
      setDim({ height, width });
    });
  }, []);
  return (
    <Image
      //   ref={img}
      source={{ uri: uri }}
      resizeMode={resizeMode}
      style={{ height: dim.height * 0.5, width: dim.width * 0.5 }}
    />
  );
};

export default ImageComponent;
